import { generatePath } from 'react-router-dom';

import type { IBreadcrumbPathItem } from '@/store/types';

import routes from '@/config/routes';
import { ResourceTypeId } from '@/store/enums';

export const getPathFromCrumb = (
  crumb: IBreadcrumbPathItem,
  level: number,
  crumbs: IBreadcrumbPathItem[],
): string | null => {
  if (level === crumbs.length - 1) {
    return null;
  }

  switch (crumb.folderType) {
    case 'category':
      return generatePath(routes.sp.scheduling.resources.category, {
        client: crumb.clientId,
        resourceType: ResourceTypeId[crumb.folderId],
      });
    case 'client':
      return generatePath(routes.sp.scheduling.resources.client, {
        client: crumb.clientId,
      });
    case 'view':
      if (!crumb.viewId) {
        return null;
      }

      return generatePath(routes.sp.scheduling.resources.view, {
        client: crumb.clientId,
        dbId: crumb.folderId,
        viewId: crumb.viewId,
      });
    case 'database':
      return generatePath(routes.sp.scheduling.resources.database, {
        client: crumb.clientId,
        dbId: crumb.folderId,
      });
    case 'home':
      return routes.sp.scheduling.resources.index;
    default:
      return generatePath(routes.sp.scheduling.resources.folder, {
        client: crumb.clientId,
        resourceType: crumb.folderType,
        folderId: crumb.folderId,
      });
  }
};
